import styled from "styled-components";
import {Tab, Tabs, TabList, TabPanel} from "react-tabs";

// import colors from '../../constants/colors'
// import breakpoints from "../../constants/breakpoints";
// import fonts from '../../constants/fonts'

export const CustomTabs = styled(Tabs)`
  width: 100%;
  display: flex;
  flex-direction: column;
  top: -70px;
  position: relative;
  font-size: 25px;
  font-weight: 400;
  line-height: 55px;
`;

export const CustomTabList = styled(TabList)`
  position: relative;
  top: -10px;
  left: 25%;
  right: 25%;
  height: 108px;
  width: 50%;
  display: flex;
  border-radius: 54px;
  background-color: #fff;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 0;
  @media screen and (max-width: 1200px) {
    width: 80%;
    height: 90px;
    left: 10%;
    right: 10%;
  }
  @media screen and (max-width: 700px) {
    width: 100%;
    left: 0;
    right: 0;
    border-radius: 0;
  }
  @media screen and (max-width: 500px) {
    height: 60px;
  }
  & > .react-tabs__tab--selected {
    background-color: #f5a462;
    color: white;
    font-weight: 400;
    &:hover {
      background-color: #f5a462;
    }
  }
`;

export const CustomTab = styled(Tab)`
  width: 30%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 76px;
  border-radius: 38px;
  border: 3px solid #f5a462;
  color: #f5a462;
  cursor: pointer;
  @media screen and (max-width: 1200px) {
    height: 60px;
  }
  @media screen and (max-width: 500px) {
    height: 40px;
    font-size: 16px;
  }
  &:hover {
    background-color: rgba(245, 164, 98, 0.6);
    color: white;
  }
`;

export const CustomTabPanel = styled(TabPanel)`
  display: none;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`;
